import { render, staticRenderFns } from "./CoBrandedPage.vue?vue&type=template&id=2980ddec&"
import script from "./CoBrandedPage.vue?vue&type=script&lang=js&"
export * from "./CoBrandedPage.vue?vue&type=script&lang=js&"
import style0 from "./CoBrandedPage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports